import {
  useGetExamSession,
  useStartExam,
  useSubmitExam,
  ExamPaperStatus,
  useGetExamResultCompletedByCardIdLazyQuery,
} from '@exam-room/graphql';
import { useTranslation } from '@exam-room/translations';
import { omit, retryWithDelay, useBeforeUnload } from '@exam-room/utils';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { LoadingSpinner } from '../../../components';
import { useConfig, type ExamFormInput } from '../../../providers';
import { PATHS } from '../../../routes/constants';

function Processing() {
  const { t } = useTranslation();
  const { examCardId = '' } = useParams();
  const navigate = useNavigate();

  // const { examCardId } = useParams();
  // const [nextModuleType, setNextModuleType] = useState(null);

  // const { cookie } = useConfig();
  // const { examSessionCookieName, domain } = cookie;

  // const { nextExamIdRef, examType } = useExam();
  // const { getValues, reset } = useExamForm();

  // const [startExam, { client }] = useStartExam();
  // const [submitExam] = useSubmitExam();
  // const [getNextModule] = useResolveNextModule({
  //   variables: { examCardId: examCardId as string },
  // });

  const [getExamResultCompletedByCardId] = useGetExamResultCompletedByCardIdLazyQuery({
    variables: { examCardId },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data.erGetExamResultByCardId) {
        navigate(generatePath(PATHS.Exam.Completed, { examCardId }));
      }
    },
  });

  // Always prevent user from leaving this page
  useBeforeUnload();

  useEffect(() => {
    if (!examCardId) return;

    const getExamResult = async () => {
      const examResult = await getExamResultCompletedByCardId();
      const isResultReady = !!examResult.data?.erGetExamResultByCardId;
      return isResultReady;
    };

    const onError = () => {
      navigate(PATHS.Error);
    };

    retryWithDelay(getExamResult, onError);
  }, [examCardId, getExamResultCompletedByCardId, navigate]);

  // useEffect(() => {
  //   async function moveToNextModule() {
  //     // 4.
  //     if (nextModuleType === NextExamModuleType.Break) {
  //       // 4.1 redirect to '/break' if type === 'BREAK' (will call startExam in that path)
  //       navigate(generatePath(PATHS.Exam.Break, { examCardId }));
  //     } else {
  //       //   4.2 call startExam with nextExamId
  //       await startExam({
  //         variables: {
  //           input: {
  //             examCardId: examCardId as string,
  //             isSetTimer: true,
  //             examId: nextExamIdRef.current as string,
  //           },
  //         },
  //         onCompleted: async (data) => {
  //           nextExamIdRef.current = null;
  //           await client.refetchQueries({ include: ['qmsExamRoomGetExam'] });
  //           const examPaperItemData =
  //             data?.qmsExamRoomStartExamInEvent?.examRoomAnswer?.examRoomExamPaperItems;
  //           const initialValues: ExamFormInput = {};
  //           examPaperItemData?.forEach((data) => {
  //             const { refId, answer, ...restData } = omit(data, ['__typename']);
  //             if (refId) {
  //               initialValues[refId] = {
  //                 ...restData,
  //                 refId,
  //                 answer: answer.value,
  //               };
  //             }
  //           });
  //           reset(initialValues);
  //           navigate(generatePath(PATHS.Exam.Root, { examCardId }));
  //         },
  //         onError: () => {
  //           navigate(PATHS.Error);
  //         },
  //       });
  //     }
  //   }
  //   if (nextExamIdRef.current) {
  //     moveToNextModule();
  //     // next module type 'FINISH' has examId === null
  //   } else if (nextModuleType === NextExamModuleType.Finish) {
  //     navigate(generatePath(PATHS.Exam.Completed, { examCardId }));
  //   }
  // }, [nextModuleType]);
  // useEffect(() => {
  //   // TODO: SET eExam - remove me
  //   navigate('/exam/c2eec581-1bea-4fbb-a9e1-321fe82de160/instruction');
  //   async function submitAndContinue() {
  //     const formValues = getValues();
  //     const rawAnswersInput = Object.values(formValues).map(({ examPaperItemId, answer }) => ({
  //       examPaperItemId,
  //       answer: { value: answer ?? '', type: 'HTML' },
  //     }));
  //     try {
  //       // 1. submit exam paper
  //       await submitExam({
  //         variables: {
  //           submitExamInput: {
  //             rawAnswers: rawAnswersInput,
  //           },
  //         },
  //       });
  //       if (Cookies.get(examSessionCookieName) && !import.meta.env.DEV) {
  //         Cookies.remove(examSessionCookieName, { domain });
  //       }
  //       // 2. polling resolveNextModule until get data back
  //       await retryWithDelay(
  //         async () => {
  //           try {
  //             await getNextModule({
  //               onCompleted: (data) => {
  //                 const { examId, type } = data.qmsResolveNextExamModuleInfo;
  //                 // 3. set nextModuleId when get data back
  //                 nextExamIdRef.current = examId;
  //                 setNextModuleType(type);
  //               },
  //             });
  //             return true;
  //           } catch {
  //             // check if error is `paper is still grading`
  //             return false;
  //           }
  //         },
  //         () => {
  //           console.error('Unable to resolve next exam module ID');
  //           navigate(PATHS.Error);
  //         },
  //       );
  //     } catch {
  //       // will reach here if cannot `getNextModule` on the first try
  //     }
  //   }
  //   if (examType === ExamType.SatMock || examType === ExamType.SatPractice) {
  //     submitAndContinue();
  //   } else {
  //     // If Exam type is `SAT`, check time of current date with endedAt before submit exam
  //     if (!loadingSessionData && !nextModuleType) {
  //       const endedAt = sessionData?.qmsExamRoomGetExamSessionAnswer?.endedAt ?? 0; // TODO: SET eExam check `endedAt` type
  //       const sessionAlreadyExpired = new Date(endedAt).getTime() < new Date().getTime();
  //       const sessionWithinOneSecondFromExpired =
  //         new Date(endedAt).getTime() - new Date().getTime() < 1000;
  //       // Timer on exam use `Math.floor` so there's often milliseconds left of session time when reach this line
  //       if (sessionAlreadyExpired || sessionWithinOneSecondFromExpired) {
  //         submitAndContinue();
  //       } else {
  //         navigate(generatePath(PATHS.Exam.Root, { examCardId }));
  //       }
  //     }
  //   }
  // }, [sessionData]);

  return (
    <div className='grid h-full w-full place-items-center bg-gray-50'>
      <div className='flex flex-col gap-6'>
        <LoadingSpinner className='h-auto w-25' />
        <div className='flex flex-col gap-2 text-center'>
          <h3 className='text-text-primary'>{t('processing.title')}</h3>
          <p className='text-text-secondary'>{t('processing.subTitle')}</p>
        </div>
      </div>
    </div>
  );
}

const ProcessingRoute = {
  path: PATHS.Exam.Processing,
  element: <Processing />,
};

export default ProcessingRoute;
